<script setup lang="ts">
import { fr } from '@nuxt/ui/locale'
</script>

<template>
  <UApp :toaster="{ position: 'top-right' }" :locale="fr">
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <!--
      Hors du layout à dessein : l'avertissement doit survivre à un changement
      de page, et rester affiché quel que soit l'écran où la révocation tombe.
    -->
    <SessionRevokedNotice />
  </UApp>
</template>
